export interface EditChefPayoutOverride {
  chefId: string
  deleteOverride: boolean
  headCount?: number | null
  grossPay?: string | null
  processingFee?: string | null
  tax?: string | null
  volumeRebateAmount?: string | null
  totalPayout?: string | null
  chefPayCategory?: string
  notes?: string
}

export interface CreateAdditionalChefPayout {
  chefId: string
  headCount: number
  grossPay: string
  processingFee: string
  tax: string
  volumeRebate: string
  totalPayout: string
  chefPayCategory: string
  notes?: string
}

export interface UpdateAdditionalChefPayout {
  chefId: string
  headCount?: number | null
  grossPay?: string | null
  processingFee?: string | null
  tax?: string | null
  volumeRebateAmount?: string | null
  totalPayout?: string | null
  chefPayCategory?: string
  notes?: string
}

export interface UpdateGroupOrderChefPayoutOverrides {
  orderId: string
  payoutOverrides: EditChefPayoutOverride[]
  createAdditionalChefPayouts?: CreateAdditionalChefPayout[]
  updateAdditionalChefPayouts?: UpdateAdditionalChefPayout[]
  deleteAdditionalChefPayoutChefIds?: string[]
}

interface UpdateChefPayoutOverridesCoordinator {
  RestService: {
    post: (path: string, body: any) => Promise<any>
  }
  HandleError: any
  UIService: {
    FlashMessage: {
      displaySuccessMessage: (message: string) => void
    }
  }
}

export const UpdateChefPayoutOverrides =
  ({
    RestService,
    HandleError,
    UIService,
  }: UpdateChefPayoutOverridesCoordinator) =>
  async (request: UpdateGroupOrderChefPayoutOverrides): Promise<any | null> => {
    try {
      const updatedGroupOrder = await RestService.post(
        '/group-orders/chefs/chef-payouts',
        request,
      )

      UIService.FlashMessage.displaySuccessMessage(
        'Chef payout overrides updated successfully',
      )

      return updatedGroupOrder
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
